import React from "react";
import { Tag, TagCloseButton, TagLabel, Wrap, WrapItem } from "@chakra-ui/react";

const DEFAULT_LABEL_MAP = {
  trade_type: "Trade Type",
  security_type: "Security Type",
  trade_direction: "Direction",
  ticker_name: "Ticker",
  from_date: "From",
  to_date: "To",
  tag_id: "Tag",
};

const DEFAULT_KEYS_TO_SKIP = ["page", "numrows"];

/**
 * Render the row of "active filter" pills with close buttons.
 *
 * `filters` is the same object that drives the request (e.g. `{ trade_type: 'Swing Trade', ... }`).
 * `tags` is consulted to display a tag's name instead of its raw id when key === 'tag_id'.
 */
const TradeFilterChips = ({
  filters,
  tags = [],
  onRemoveFilter,
  labelMap = DEFAULT_LABEL_MAP,
  keysToSkip = DEFAULT_KEYS_TO_SKIP,
}) => {
  const activeFilters = Object.entries(filters || {}).filter(
    ([key]) => !keysToSkip.includes(key)
  );

  if (activeFilters.length === 0) return null;

  return (
    <Wrap spacing={2}>
      {activeFilters.map(([key, value]) => {
        let displayValue = value;
        if (key === "tag_id") {
          const matchedTag = tags.find(
            (t) => String(t.tag_id) === String(value)
          );
          displayValue = matchedTag ? matchedTag.name : value;
        }
        return (
          <WrapItem key={key}>
            <Tag size="sm" borderRadius="full" variant="subtle" colorScheme="blue">
              <TagLabel>
                {labelMap[key] || key}: {displayValue}
              </TagLabel>
              <TagCloseButton onClick={() => onRemoveFilter(key)} />
            </Tag>
          </WrapItem>
        );
      })}
    </Wrap>
  );
};

export default TradeFilterChips;
